// Note Tool — sticky note annotations on the canvas.
// Shares shortcut I with Eyedropper.

import { screenToDoc } from "../render/Viewport";
import type { PointerSample, Tool, ToolContext } from "./Tool";

export interface CanvasNote {
  id: string;
  x: number;
  y: number;
  text: string;
  color: string; // CSS color for the note background
  collapsed: boolean;
}

export class NoteTool implements Tool {
  readonly id = "note";
  readonly shortcut = "I";

  /** Notes for the current document. */
  notes: CanvasNote[] = [];

  private placing = false;
  private currentNote: CanvasNote | null = null;

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    if (!ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    // Check if clicking on existing note to select/edit
    for (const note of this.notes) {
      if (Math.abs(note.x - p.x) < 20 && Math.abs(note.y - p.y) < 20) {
        this.currentNote = note;
        this.editNoteText(note);
        return;
      }
    }

    // Place new note
    const note: CanvasNote = {
      id: crypto.randomUUID(),
      x: p.x, y: p.y,
      text: "",
      color: "#ffffcc",
      collapsed: false,
    };
    this.notes.push(note);
    this.currentNote = note;
    this.placing = true;
    this.editNoteText(note);
    ctx.requestRender();
  }

  onPointerMove(ctx: ToolContext, s: PointerSample): void {
    if (!this.placing || !this.currentNote) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);
    this.currentNote.x = p.x;
    this.currentNote.y = p.y;
    ctx.requestRender();
  }

  onPointerUp(ctx: ToolContext): void {
    this.placing = false;
  }

  private editNoteText(note: CanvasNote): void {
    const input = prompt("Note text:", note.text);
    if (input !== null) {
      note.text = input;
    }
  }

  /** Remove a note by ID. */
  removeNote(id: string): void {
    this.notes = this.notes.filter(n => n.id !== id);
  }

  /** Clear all notes. */
  clearAll(): void {
    this.notes = [];
  }
}
